// ロックされたレースの表示（Issue #36）。
//
// #262 で有料化をやめたため、予想ページ（FREE_TIER）では `locked` が来なくなり、通常は表示されない。
// 応答に `locked` が残っていた場合の保険として、申込への導線を持たない案内だけを出す。
// 中央・地方・競輪の3コンテンツで共用する。
import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { contentLabel } from '../../constants/contents';

function LockedRaceNotice({ contentKey, raceName }) {
  const label = contentLabel(contentKey);

  return (
    <Paper
      sx={{
        p: { xs: 3, sm: 5 },
        borderRadius: 4,
        textAlign: 'center',
        color: '#eef8ff',
        border: '1px solid rgba(92, 160, 219, 0.18)',
        background: 'linear-gradient(180deg, rgba(10,24,41,0.84), rgba(4,10,20,0.9))',
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            border: '1px solid rgba(92, 160, 219, 0.28)',
            bgcolor: 'rgba(8, 18, 32, 0.72)',
          }}
        >
          <LockOutlinedIcon sx={{ color: '#9ed7ff' }} />
        </Box>

        <Typography sx={{ fontSize: { xs: 20, sm: 26 }, fontWeight: 700 }}>
          {label}の{raceName ? `${raceName} の` : ''}予想は現在表示できません
        </Typography>

        <Typography sx={{ color: 'rgba(203, 229, 245, 0.72)', maxWidth: 560 }}>
          時間をおいてページを再読み込みしてください。
        </Typography>
      </Stack>
    </Paper>
  );
}

export default LockedRaceNotice;
